import React from 'react';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import AreaGraphCharts from '../../ui/areaChart/AreaChart';
import ProjectedORChart from '../../ui/ProjectedOrCharts/ProjectedOrChart';
import ProjectOrActionTable from '../../ui/tables/projectedOr/ProjectOrActionTable';
import ProjectedORTable from '../../ui/tables/projectedOr/ProjectedOrTable';
import WeeklyOrActionTable from '../../ui/tables/weeklyOr/WeeklyOrActionTable';

const WeeklyOr = ({ isOn, isSWitchOn }) => {
  const { state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const weeklyOrData = state.dashboardData.weeklyOr;
  const actionFilter = state.filters.actionFilter;
  const loader = state.dashboardData.isLoading.projectedOR;
  const weeklyOrTableData = state.dashboardData.weeklyOrTable;

  if (loader) return <ChartSkeleton isOn={isOn} />;

  return (
    <>
      {globalViewMode === 'graph' ? (
        actionFilter ? (
          <AreaGraphCharts
            data={weeklyOrData[0]?.["Week 22"] || []}
            dataKey="week"
            gradients={[["#FC0", "#101444"], ["#cdc", "#101444"]]}
            graphsNames={["plan", "projected"]}
            activeDots={["#FC0", "#cdc"]}
            minWidthNeeded
            customDots
            MyTooltipComponent={(props) => (
              <div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <span style={{ width: '8px', height: '8px', backgroundColor: '#FC0' }} />
                  <span>Plan : {props.payload?.plan}</span>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <span style={{ width: '8px', height: '8px', backgroundColor: '#cdc' }} />
                  <span>Projected : {props.payload?.projected}</span>
                </div>
              </div>
            )}
          />
        ) : (
          <ProjectedORChart
            data={isOn ? weeklyOrData : weeklyOrData.slice(-4)}
            minWidth={isOn ? 100 : 0}
            showActual
          />
        )
      ) : actionFilter ? (
        !isSWitchOn ? (
          <ProjectOrActionTable
            data={isOn ? weeklyOrTableData : weeklyOrTableData.slice(-4)}
            isOn={!isSWitchOn}
          />
        ) : (
          <WeeklyOrActionTable data={weeklyOrData} isOn={isOn} />
        )
      ) : (
        <ProjectedORTable
          data={
            !isSWitchOn
              ? isOn
                ? weeklyOrTableData
                : weeklyOrTableData.slice(-4)
              : isOn
              ? weeklyOrData
              : weeklyOrData.slice(-4)
          }
          isOn={!isSWitchOn}
        />
      )}
    </>
  );
};

export default WeeklyOr;
